import { AttachmentModel } from './AttachmentModel'
import { IncidentPostData } from './IncidentPostData'
import { arrayFromJSONValue, dateOptionalFromJSONValue, stringFromJSONValue } from './parser'

export class IncidentPostModel {
  recordID: string
  incidentID: string
  message: string
  attachments: AttachmentModel[]
  recordCreatedDateTime?: Date
  lastUpdateDateTime?: Date

  public constructor(
    recordID: string,
    incidentID: string,
    message: string,
    attachments: AttachmentModel[],
    recordCreatedDateTime?: Date,
    lastUpdateDateTime?: Date
  ) {
    this.recordID = recordID
    this.incidentID = incidentID
    this.message = message
    this.attachments = attachments
    this.recordCreatedDateTime = recordCreatedDateTime
    this.lastUpdateDateTime = lastUpdateDateTime
  }

  public static modelFromJSON(json: any): IncidentPostModel {
    return new IncidentPostModel(
      stringFromJSONValue(json['ID']),
      stringFromJSONValue(json['IncidentID']),
      stringFromJSONValue(json['Message']),
      arrayFromJSONValue(json['Attachments']).map(value => AttachmentModel.modelFromJSON(value)),
      dateOptionalFromJSONValue(json['RecordCreated']),
      dateOptionalFromJSONValue(json['LastUpdated'])
    )
  }

  public toMutableData(): IncidentPostData {
    return {
      id: this.recordID,
      incidentID: this.incidentID,
      message: this.message,
      attachments: this.attachments.map(model => ({
        File: model.file,
        Name: model.name,
        Type: model.type,
        Refresh: model.refresh,
        Width: model.width,
        Height: model.height
      })),
      imagesToAdd: []
    }
  }
}
